import * as XLSX from "xlsx";
import moment from "moment";

const DATE_FIELDS = new Set(["marcaTemporal"]);
export function exportOperacionesToExcel(rows = [], fields = [], filename = "Operaciones.xlsx") {
  const visibleFields = fields.filter((f) => !f.excelHidden);
  const header = visibleFields.map((f) => f.label);
  const keys = visibleFields.map((f) => f.key);

  // --- Mapas para controlar correlativo de OC y la primera fila (Cabecera) ---
  const ocMap = new Map();
  const cabeceraSet = new Set();
  let noOcSecuencial = 1;

  const data = rows.map((row) => {
    const ruc = row.ruc ? String(row.ruc).trim() : "";
    const tienda = row.tienda ? String(row.tienda).trim() : "";
    const llave = `${ruc}${tienda}`;

    if (!ocMap.has(llave)) {
      ocMap.set(llave, noOcSecuencial++);
    }
    const noOc = ocMap.get(llave);

    const cabePos = cabeceraSet.has(llave) ? "P" : "C";
    cabeceraSet.add(llave);

    const enrichedRow = {
      ...row,
      llave,
      noOc,
      cabePos,
    };

    return keys.map((key) => {
      const value = enrichedRow[key];
      if (DATE_FIELDS.has(key) && value) {
        return moment(value).format("YYYY-MM-DD HH:mm:ss");
      }
      return value ?? "";
    });
  });

  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Operaciones");
  XLSX.writeFile(workbook, filename);
}

export function readExcelFileAsRows(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        resolve(XLSX.utils.sheet_to_json(sheet, { defval: "" }));
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });
}

const IMPORT_TEMPLATE_HEADERS = ["RUC", "Tienda", "Material", "OC", "MIGO"];
const IMPORT_TEMPLATE_EXAMPLE = [
  "20123456789",
  "TIENDA SAN ISIDRO",
  "30003849",
  "4500123456",
  "5000123456",
];

export function downloadOperacionesImportTemplate(filename = "Plantilla_Carga_OC_Migo.xlsx") {
  const worksheet = XLSX.utils.aoa_to_sheet([
    IMPORT_TEMPLATE_HEADERS,
    IMPORT_TEMPLATE_EXAMPLE,
  ]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla");
  XLSX.writeFile(workbook, filename);
}

export function exportImportErrorsToExcel(rows = [], filename = "Errores_Carga_OC_Migo.xlsx") {
  const header = ["Fila", "RUC", "Tienda", "Material", "OC", "MIGO", "Motivo"];
  const data = rows.map((row) => [
    row.rowNumber,
    row.ruc,
    row.tienda,
    row.material,
    row.numeroOc,
    row.migo,
    row.reason,
  ]);
  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");
  XLSX.writeFile(workbook, filename);
}